import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import TbPageHero from "./components/TbPageHero";
import TbIntroSection from "./components/TbIntroSection";
import TbWhyChoose from "./components/TbWhyChoose";
import TbHowItWorksSection from "./components/TbHowItWorksSection";
import TbCustomerAppSection from "./components/TbCustomerAppSection";
import TbPanelsSection from "./components/TbPanelsSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import TbCtaBanner from "./components/TbCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "./taxi-booking.css";

const TaxiBookingPage: React.FC = () => {
  useEffect(() => {
    document.title =
      "Taxi Booking App Like Uber and Ola | WebTech Software Solutions Bangalore";
    const description =
      "WebTech builds Uber and Ola clone taxi booking apps in Bangalore — customer, driver, and admin panels with GPS tracking, payments, and ride management.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page tb-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <TbPageHero />
            <TbIntroSection />
            <TbWhyChoose />
            <TbHowItWorksSection />
            <TbCustomerAppSection />
            <TbPanelsSection />
            <WdevTestimonials />
            <TbCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default TaxiBookingPage;
